module.exports = __webpack_public_path__ + "static/loading-acd14ff757de4218d137e7d3a7763c51.gif";